import { render, staticRenderFns } from "./ChecklistBoolFieldModule.vue?vue&type=template&id=e8534e86&scoped=true"
import script from "./ChecklistBoolFieldModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChecklistBoolFieldModule.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChecklistBoolFieldModule.vue?vue&type=style&index=0&id=e8534e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8534e86",
  null
  
)

export default component.exports